module.exports = __webpack_public_path__ + "img/snackDownload3.6df6e69.png";